import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useIsCurrentUserPublic_session$key } from "./__generated__/useIsCurrentUserPublic_session.graphql";

export const useIsCurrentUserPublic = (
  sessionRef: useIsCurrentUserPublic_session$key | null
) => {
  const session = useFragment(useIsCurrentUserPublicFragmentString, sessionRef);
  return session?.currentClientProfile?.member?.clientClass === "CUSTOMER";
};

const useIsCurrentUserPublicFragmentString = graphql`
  fragment useIsCurrentUserPublic_session on Session {
    currentClientProfile {
      member {
        clientClass
      }
    }
  }
`;
